
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

// icons
const icons = {
  ArrowForwardIosIcon
};

// ==============================|| MENU ITEMS - UTILITIES ||============================== //

const oms = {
  id: 'oms',
  title: 'Pharma',
  type: 'group',
  children: [
      {
      id: 'party',
      title: 'Party',
      type: 'item',
      url: '/party',
      icon: icons.ArrowForwardIosIcon
  },  {
      id: 'product',
      title: 'Product',
      type: 'item',
      url: '/product',
      icon: icons.ArrowForwardIosIcon
  },  {
      id: 'composition',
      title: 'Composition',
      type: 'item',
      url: '/composition',
      icon: icons.ArrowForwardIosIcon
  },  {
      id: 'productcomposition',
      title: 'Productcomposition',
      type: 'item',
      url: '/productcomposition',
      icon: icons.ArrowForwardIosIcon
  },  {
      id: 'po',
      title: 'Po',
      type: 'item',
      url: '/po',
      icon: icons.ArrowForwardIosIcon
  },  {
      id: 'orderpomapping',
      title: 'Orderpomapping',
      type: 'item',
      url: '/orderpomapping',
      icon: icons.ArrowForwardIosIcon
  },  {
      id: 'pharmaorder',
      title: 'Pharmaorder',
      type: 'item',
      url: '/pharmaorder',
      icon: icons.ArrowForwardIosIcon
  },  {
      id: 'phpackagingmaterial',
      title: 'Phpackagingmaterial',
      type: 'item',
      url: '/phpackagingmaterial',
      icon: icons.ArrowForwardIosIcon
  },  {
      id: 'designvendor',
      title: 'Designvendor',
      type: 'item',
      url: '/designvendor',
      icon: icons.ArrowForwardIosIcon
  },  {
      id: 'phproductform',
      title: 'Phproductform',
      type: 'item',
      url: '/phproductform',
      icon: icons.ArrowForwardIosIcon
  },  {
      id: 'phproduct',
      title: 'Phproduct',
      type: 'item',
      url: '/phproduct',
      icon: icons.ArrowForwardIosIcon
  },  {
      id: 'phproductstatus',
      title: 'Phproductstatus',
      type: 'item',
      url: '/phproductstatus',
      icon: icons.ArrowForwardIosIcon
  },  {
      id: 'phproductshape',
      title: 'Phproductshape',
      type: 'item',
      url: '/phproductshape',
      icon: icons.ArrowForwardIosIcon
  },  {
      id: 'phdesign',
      title: 'Phdesign',
      type: 'item',
      url: '/phdesign',
      icon: icons.ArrowForwardIosIcon
  },  {
      id: 'productasset',
      title: 'Productasset',
      type: 'item',
      url: '/productasset',
      icon: icons.ArrowForwardIosIcon
  },  {
      id: 'rmunit',
      title: 'Rmunit',
      type: 'item',
      url: '/rmunit',
      icon: icons.ArrowForwardIosIcon
  },  {
      id: 'rawmaterial',
      title: 'Rawmaterial',
      type: 'item',
      url: '/rawmaterial',
      icon: icons.ArrowForwardIosIcon
  },  {
      id: 'productraw',
      title: 'Productraw',
      type: 'item',
      url: '/productraw',
      icon: icons.ArrowForwardIosIcon
  },  {
      id: 'rawdemand',
      title: 'Rawdemand',
      type: 'item',
      url: '/rawdemand',
      icon: icons.ArrowForwardIosIcon
  },  {
      id: 'productrawtorawdemand',
      title: 'Productrawtorawdemand',
      type: 'item',
      url: '/productrawtorawdemand',
      icon: icons.ArrowForwardIosIcon
  },  {
      id: 'rmvendor',
      title: 'Rmvendor',
      type: 'item',
      url: '/rmvendor',
      icon: icons.ArrowForwardIosIcon
  },  {
      id: 'rmvendorquotation',
      title: 'Rmvendorquotation',
      type: 'item',
      url: '/rmvendorquotation',
      icon: icons.ArrowForwardIosIcon
  }
  ]
};

export default oms;